import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { FabricCompareModalComponent } from '../../../features/fabrics/components/fabric-compare-modal/fabric-compare-modal.component';
import { FabricVariationModel } from '../../models/fabric-variation.model';
import { FabricComparisonService } from '../../services/fabric-comparison.service';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { NzImageModule } from 'ng-zorro-antd/image';
import { fallbackImage } from '../../utils/image.util';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'app-fabric-comparison-banner',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, NzButtonModule, NzIconModule, NzImageModule, TranslatePipe],
  templateUrl: './fabric-comparison-banner.component.html',
  styleUrls: ['./fabric-comparison-banner.component.scss'],
})
export class FabricComparisonBannerComponent {
  readonly comparisonService: FabricComparisonService;

  readonly fallback = fallbackImage;

  constructor(
    comparisonService: FabricComparisonService,
    private readonly modalService: ModalService
  ) {
    this.comparisonService = comparisonService;
  }

  remove(fabric: FabricVariationModel): void {
    this.comparisonService.remove(fabric.uuid);
  }

  clear(): void {
    this.comparisonService.clear();
  }

  openCompareModal(): void {
    const fabrics = this.comparisonService.fabrics();
    if (fabrics.length < 2) return;

    this.modalService.create(FabricCompareModalComponent, {
      fabricUUIDs: fabrics.map((f) => f.uuid),
    });
  }
}
